import GROUP from '../../../DOM/GROUP/GROUP.js';
import TR from '../../../DOM/table/TGROUP/ROW/TR.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const tgroupAttr = makeAttrStruct([
    ['class'],
    ['name'] // Optional name for the group
]);
export const tgroupData = makeDataStruct([]);
export const tgroupModel = makeStruct([
    ['attributes', tgroupAttr],
    ['data', tgroupData]
]);
// Simplified Model
export function tgroup(className, name) {
    return {
        attributes: tgroupAttr(className, name),
        data: tgroupData()
    };
}
/** A TABLE GROUP (TGROUP) element: ie: THEAD, TBODY, TFOOT */
export default class TGROUP extends GROUP {
    // declare public node: TABLE<TableElementModel>;
    // constructor(node: TABLE<TableElementModel>, element: HTMLELEMENT.THEAD | HTMLELEMENT.TBODY | HTMLELEMENT.TFOOT, model: M) {
    constructor(node, element, model) {
        super(node, element, model);
        this.addClass('table-group');
    }
    /** Adds the given table-row to this table-group */
    addRow(model) {
        return this.addChild(new TR(this, model));
    }
    // /** Returns this group's table */
    // getTable(): TABLE<TableElementModel> {
    // 	return this.node;
    // }
    /** Retrieves an array of child TR Elements */
    getRows() {
        return this.get(null, 'TR');
    }
}
